import React from "react";
import _ from "lodash";
import classnames from "classnames";

import Select from "components/Select";
import IMeta from "models/IMeta";
import { ArrowBack, ArrowForward } from "components/Icons";
import { PAGE_SIZE_OPTIONS } from "constants/.";

import "./Pagination.scss";

interface IProps {
  meta: IMeta;
  onPageChange: (meta?: IMeta) => void;
  pageName?: string;
}

class Pagination extends React.Component<IProps> {
  public pagination = (current, last) => {
    const delta = 2;
    const left = current - delta;
    const right = current + delta + 1;
    const range = [] as any;
    const rangeWithDots = [] as any;
    let l;

    for (let i = 1; i <= last; i++) {
      if (i === 1 || i === last || (i >= left && i < right)) {
        range.push(i);
      }
    }

    for (const i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push(-1);
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  };

  public onPageSizeChange = (data) => {
    const { pageName, onPageChange } = this.props;
    const pageSize = _.get(data, "value", 10);

    if (pageName) {
      const savedSettings = JSON.parse(
        localStorage.getItem("customSettings") || "{}"
      );
      _.set(savedSettings, `${pageName}.pageSize`, pageSize);

      localStorage.setItem("customSettings", JSON.stringify(savedSettings));
    }

    onPageChange({
      pageSize,
      currentPage: 0,
    });
  };

  public render() {
    const {
      meta: { count = 0, currentPage = 0, pageSize = 10 },
      onPageChange,
    } = this.props;

    const pageRange = this.pagination(
      currentPage + 1,
      _.ceil(count / pageSize)
    );

    return (
      <div className="cnb-pagination-container">
        <div className="cnb-pagesize">
          <Select
            onChange={this.onPageSizeChange}
            options={PAGE_SIZE_OPTIONS}
            selectedOption={pageSize}
            className="text-12"
            clearable={false}
          />
        </div>
        <div className="cnb-pagination">
          <div
            className={classnames("pagination-cell", {
              disabled: currentPage < 1,
            })}
            onClick={() => onPageChange({ currentPage: currentPage - 1 })}
          >
            <ArrowBack />
          </div>
          {pageRange.map((page, i) => (
            <div
              className={classnames("pagination-cell", {
                active: page - 1 === currentPage,
              })}
              key={i}
              onClick={() =>
                page > 0 && onPageChange({ currentPage: page - 1 })
              }
            >
              <span>{page === -1 ? "..." : page}</span>
            </div>
          ))}
          <div
            className={classnames("pagination-cell", {
              disabled: currentPage >= count / pageSize - 1,
            })}
            onClick={() => onPageChange({ currentPage: currentPage + 1 })}
          >
            <ArrowForward />
          </div>
        </div>
      </div>
    );
  }
}

export default Pagination;
